export function parseTagIds(value) {
  if (!value) {
    return [];
  }

  return String(value)
    .split(',')
    .map((id) => id.trim())
    .filter(Boolean);
}

export function serializeTagIds(ids) {
  if (!ids || ids.length === 0) {
    return '';
  }

  return [...new Set(ids.map(String))].join(',');
}
